import { useEffect } from 'react';
import { segmentIntegrations } from 'components/shared/analytics/segment';
import { ADHD_ASSESSMENT_QUESTIONS } from 'components/shared/analytics/segment-events';
import AssessmentIntro from 'components/assessment-intro';
import { clearAssessmentData } from 'components/shared/utils';
import { useHistory } from 'react-router-dom';

const ADHDSelfTest = (): JSX.Element => {
  const history = useHistory();
  const content = {
    title: 'ADHD screener',
    description:
      'To complete this evaluation, think about your mental health experiences over the last six months.'
  };

  useEffect(() => {
    clearAssessmentData();
  }, []);

  const handleNextPage = () => {
    window.analytics?.track(
      ADHD_ASSESSMENT_QUESTIONS,
      { title: content.title },
      segmentIntegrations
    );

    history.push('/adhd-assessment');
  };

  return (
    <AssessmentIntro
      handleNextPage={handleNextPage}
      title={content.title}
      description={content.description}
    />
  );
};

export default ADHDSelfTest;
